<template>
  <pt-hospital-detail class="pt-hospital-detail__page"></pt-hospital-detail>
</template>

<script>
import PtHospitalDetail from 'cps/hospital-and-doctor-manage/pt-hospital-manage/pt-hospital-detail/withData'
export default {
  name: 'pt-hospital-detail__view',
  components: {
    'pt-hospital-detail': PtHospitalDetail
  }
}
</script>
